var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-promo",staticStyle:{"height":"calc(100vh - 395px)"}},[_vm._v(" PromoMaterials.vue ")])
}
var staticRenderFns = []

export { render, staticRenderFns }